module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasVideos) ? _c('div', {
    staticClass: "page-organizations-card-videos"
  }, [(_vm.currentVideoIndex > 0) ? _c('button', {
    staticClass: "page-organizations-card-videos__button",
    attrs: {
      "type": "button",
      "aria-label": "Предыдущее видео"
    },
    on: {
      "click": _vm.showPrevious
    }
  }, [_vm._v("\n    ‹\n  ")]) : _vm._e(), (_vm.currentVideo) ? _c('div', {
    key: _vm.currentVideo.id,
    staticClass: "page-organizations-card-videos__item",
    domProps: {
      "innerHTML": _vm._s(_vm.currentVideo.video)
    }
  }) : _vm._e(), (_vm.currentVideoIndex < _vm.videos.length - 1) ? _c('button', {
    staticClass: "page-organizations-card-videos__button page-organizations-card-videos__button_right",
    attrs: {
      "type": "button",
      "aria-label": "Следующее видео"
    },
    on: {
      "click": _vm.showNext
    }
  }, [_vm._v("\n    ›\n  ")]) : _vm._e()]) : _c('center', [_vm._v("К сожалению, данная организация еще не добавила видео")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617c99b4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/organizations/card/videos/component.vue
// module id = 0d3064d1ca517e553829
// module chunks = 1